import { FC } from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import {
  CHART_SHADOW,
  CUSTOM_REVENUE_TOOLTIP,
  GBP_SYMBOL,
  MONTHS,
} from "lib/constants";
import { calculateMonthlyData } from "lib/utils/monthly-data-util";

interface ClinicRevenueChartProps {
  data: RevenueEntry[];
  width?: string | number;
  height?: string | number;
  className?: string;
}

const ClinicRevenueChart: FC<ClinicRevenueChartProps> = ({
  data,
  width = "100%",
  height = "100%",
  className,
}) => {
  const { monthlyData: monthlyRevenue, yAxisMax } = calculateMonthlyData(
    data,
    "revenue"
  );

  const series = [
    {
      name: "Monthly Revenue",
      data: monthlyRevenue,
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: "line",
      toolbar: { show: false },
      zoom: { enabled: false },
      dropShadow: CHART_SHADOW,
    },
    xaxis: {
      categories: MONTHS,
      title: { text: "Months" },
      labels: {
        style: { fontSize: "12px" },
      },
    },
    yaxis: {
      max: yAxisMax,
      min: 0,
      title: { text: "Revenue (GBP)" },
      labels: {
        formatter: (val) => `${GBP_SYMBOL}${val}`,
      },
    },
    tooltip: {
      custom: CUSTOM_REVENUE_TOOLTIP,
    },

    stroke: {
      curve: "smooth",
      width: 3,
    },
    markers: {
      size: 4,
      hover: {
        size: 5,
      },

      colors: ["#fff"],
      strokeColors: "black",
      strokeWidth: 2,
    },
    colors: ["black"],
    grid: {
      borderColor: "#e0e0e0",
      strokeDashArray: 4,
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      position: "top",
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="line"
      width={width}
      height={height}
      className={className}
    />
  );
};

export default ClinicRevenueChart;
